module.exports = __webpack_public_path__ + "img/message.f21d8d0e.png";